<template>
  <div class="mobile_vote">
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="goBack()">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <span class="mobile_head_desc"> </span>
      <div class="mobile_head_right">
        <a @click="refresh()">
          <i class="el-icon-refresh-right"></i>
        </a>
      </div>
    </div>
    <div class="mobile_vote_bar" ref="mobileVoteBar">
      <div class="mobile_bar_main">
        <div class="mobile_bar_title">
          {{ voteInfo.VoteName }}
        </div>
        <div class="mobile_bar_tips" v-if="voteInfo.Status === 1">
          未投票评委（{{ voteProgress.NotVoteUserList.length }}）
        </div>
        <div class="mobile_bar_tips" v-if="voteInfo.Status === 3">投票结果</div>
        <div class="mobile_bar_highlight"></div>
      </div>
    </div>
    <div class="mobile_vote_main" :style="voteMainStyle">
      <div class="not_vote_user_box" v-if="voteInfo.Status === 1">
        <div
          class="not_vote_user_box_item"
          v-for="(item, index) in voteProgress.NotVoteUserList"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div
        class="mobile_project_box"
        v-for="(project, index) in voteResultInfo.VoteProjectList"
        :key="index"
      >
        <div class="project_item">
          <div class="project_title">
            {{ project.Ranking }}、{{ project.ProjectName }}
          </div>
        </div>
        <div class="project_item">
          <i class="el-icon-s-opportunity icon_left icon_primary"></i>
          <div class="content">
            {{ project.Remark }}
          </div>
          <a
            @click="
              project.IsShowAdditionalRemark = !project.IsShowAdditionalRemark
            "
          >
            <i
              class="el-icon-caret-bottom icon_right icon_primary"
              :style="
                project.IsShowAdditionalRemark
                  ? 'transform: rotate(-180deg);transition: all .5s'
                  : 'transform: rotate(0deg);transition: all .5s'
              "
            ></i>
          </a>
        </div>
        <div class="project_item" v-show="project.IsShowAdditionalRemark">
          <i
            class="el-icon-s-opportunity icon_left icon_warning"
            v-show="project.Remark1"
          ></i>
          <div class="content" v-html="project.Remark1"></div>
        </div>
        <div class="project_item">
          <div class="content">
            <span class="font_primary" v-if="voteInfo.VoteType === 0">
              {{ project.ProjectRecordState }}
            </span>
            <span class="font_primary" v-if="voteInfo.VoteType === 1">
              当前排序：{{ project.VoteNum }}
            </span>
            <span class="font_primary" v-if="voteInfo.VoteType === 2">
              得分：{{ project.AllScore }}
            </span>
          </div>
          <div class="text_right">原序号：{{ project.ProjectSort }}</div>
        </div>
      </div>
    </div>
    <div class="mobile_vote_operate_box">
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        @click="goBack()"
      >
        返回列表
      </el-button>
    </div>
  </div>
</template>

<script>
import voteManageApi from '../../api/vote/voteManage'
import voteApi from '../../api/mobileVote/vote'
export default {
  data () {
    return {
      voteMainStyle: {
        marginTop: '100px'
      },
      voteInfo: {},
      voteProgress: {
        NotVoteUserList: []
      },
      voteResultInfo: {
        VoteProjectList: []
      }
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
    },
    refresh: function () {
      this.getVoteDetail()
    },
    getVoteDetail: function () {
      const _this = this
      _this.openLoading()
      voteManageApi.getVoteDetail({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteInfo = data
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })
        if (_this.voteInfo.Status === 1) {
          _this.getVoteProgress()
        }
        if (_this.voteInfo.Status === 3) {
          _this.getVoteResult()
        }
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getVoteProgress: function () {
      const _this = this
      _this.openLoading()
      voteManageApi.getVoteProgressInfo({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteProgress = data
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getVoteResult: function () {
      const _this = this
      _this.openLoading()
      _this.voteResultInfo = {}
      voteApi.getVoteResult({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteResultInfo = data
        _this.voteResultInfo.VoteProjectList.forEach(item => {
          _this.$set(item, 'IsShowAdditionalRemark', false)
        })
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    }
  },
  created () {
    this.openLoading()
    this.getVoteDetail()
  }
}
</script>

<style lang="less">
@import '../../assets/css/mobileVote/vote.css';
</style>
